<template>
  <div>
    <SubTitle text="Administrador de pedidos">
      <el-dropdown trigger="click"
                   class="right"
                   @command="addSocs">
        <el-button size="small"
                   class="default">
          CARGAR POR<i class="el-icon-arrow-down el-icon--right"/>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="SUBORDEN"
                            icon="fas fa-box">Lista de socs</el-dropdown-item>
          <el-dropdown-item command="DOCUMENTO"
                            icon="fas fa-bookmark">Tipo de documento</el-dropdown-item>
          <el-dropdown-item command="LPN"
                            icon="fas fa-barcode">LPN package</el-dropdown-item>
          <el-dropdown-item command="EXCEL"
                            icon="fas fa-file-excel">Subir excel</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-cascader
        v-model="setSector"
        clearable
        ref="cascadeSuborder"
        placeholder="Forzar sector de ..."
        :options="optionsToForce"
        :disabled="disabledMassiveOptions || sectors.length < 1"
        @change="SetSectorMassive"
        @visible-change="getOptionsToForce"
        class="select-sectors right"
        size="mini">
        <template slot-scope="{ data }">
          <span v-if="!['selected', 'paginated'].includes(data.value)"
                class="circle-color"
                :style="{ backgroundColor: getSectorColor(data.value)}"/>
          {{ data.label }}
        </template>
      </el-cascader>
      <label class="label-set-sector right">FORZAR SECTOR</label>
    </SubTitle>
    <div class="card-section">
      <div class="card-navbar">
        <ActionSimple name="Descargar órdenes"
                        icon="far fa-file-excel"
                        @action="exportXLSX('subordenes')"
                        :disabled="list.length < 1"/>
        <ActionSimple name="No encontradas"
                        icon="el-icon-document-copy"
                        @action="copyNotFound"
                        :disabled="list | existNotFound"/>
        <ActionSimple name="Agregar splits"
                        icon="fas fa-cubes"
                        color="amber"
                        @action="getSplits"
                        :disabled="list.filter(s => s.splits).length < 1"/>
        <ActionMultiple name="Eliminar"
                        icon="el-icon-delete"
                        :options="optionsToDelete"
                        @action="deleteSocs"
                        :disabled="disabledMassiveOptions"/>
        <ActionSimple name="Centroide"
                        icon="fas fa-map-marked-alt"
                        class="right"
                        @action="inCentroide"
                        :active="this.filterCentroide"
                        :disabled="list.filter(s => s.geostate === 4).length < 1"/>
        <ActionSimple name="Limpiar filtros"
                        icon="fas fa-filter"
                        class="right"
                        @action="clearFilter"
                        :disabled="filterEnable < 1"/>
      </div>
      <p v-if="list.length < 1" class="msg-not-sector">NINGUNA SOC INGRESADA</p>
      <el-table
        v-else
        :data="suborderPaged"
        ref="tableSuborder"
        @selection-change="handleSelectionChange"
        @filter-change="applyFilter"
        :row-class-name="getRowClassName">
        <el-table-column type="selection"/>
        <el-table-column
          prop="sectors"
          label="Sector"
          column-key="sector"
          :filters="filterSectorData">
          <template slot-scope="scope">
            <span v-if="haveSplits(scope.row)"
                  class="status-soc">
              <i class="fas fa-cubes"/>contiene splits
            </span>
            <span v-else-if="notFound(scope.row)"
                  class="status-soc">
              <i  class="fas fa-question"/>no encontrado
            </span>
            <span v-else-if="notPlannable(scope.row)"
                  class="status-soc">
              <i class="fas fa-times"/>no planificable
            </span>
            <span v-else>
              <!-- Mostrar sector del Excel si existe -->
              <span v-if="scope.row.excelSector"
                    class="excel-sector-tag">
                <i class="fas fa-file-excel"/>
                {{ scope.row.excelSector }}
              </span>
              
              <!-- Mostrar sectores del sistema -->
              <span v-if="scope.row.sectors.length >  0 ">
                <span v-for="s in scope.row.sectors"
                      class="sector-tag"
                      :style="{ backgroundColor: s.color }"
                      :key="s.id">
                  {{ s.name }}
                </span>
              </span>
              
              <!-- Select para forzar sector solo si no tiene sector del Excel -->
              <el-select  v-model="scope.row.forceSector"
                          v-else-if="sectors.length > 0 && !scope.row.excelSector"
                          @change="getSectorOfSuborder(scope.row)"
                          placeholder="Forzar sector"
                          size="mini"
                          class="select-in-table"
                          clearable>
                  <el-option  v-for="sector in sectors"
                              :key="sector.id"
                              :label="sector.name"
                              :value="sector.id"/>
                </el-select>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          label="SOC"
          prop="suborder"/>
        <el-table-column
          sortable
          label="LPN"
          prop="lpn"/>
        <el-table-column
          sortable
          label="Vol."
          prop="volume"
          :formatter="formatVolume"
          column-key="volume"/>
        <el-table-column
          sortable
          label="Tipo"
          prop="document_type_name"
          column-key="document"
          :filters="filterDocumentTypeData">
        </el-table-column>
        <el-table-column
          sortable
          label="Localidad"
          prop="locality"
          column-key="locality"
          :filters="filterLocalityData">
        </el-table-column>
        <el-table-column
          sortable
          label="Estado"
          prop="last_state_name"
          column-key="states"
          align="center"
          :filters="filterStateData">
          <template slot-scope="scope">
            <span v-if="[5, 6].includes(scope.row.last_state)"
                  class="tag-red">
               {{scope.row.last_state_name}}
            </span>
            <span v-else>
              {{scope.row.last_state_name}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          label="Tamaño"
          prop="package_type_name"
          column-key="package"
          align="center"
          :filters="filterPackageTypeData">
          <template slot-scope="scope">
            <span v-if="scope.row.package_type_name === 'NF'"
                  class="tag-red">
               no informado por TRL
            </span>
            <span v-else>
              {{scope.row.package_type_name}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          label="Fecha"
          prop="requested_at"
          :formatter="formatDate"
          column-key="requested"
          align="center"
          :filters="filterRequestedAtData">
        </el-table-column>
        <el-table-column
          label="Observaciones"
          width="200"
          v-slot="scope">
          <div v-if="scope.row.observations && scope.row.observations.length > 0" class="observations-column">
            <el-tooltip v-for="(obs, index) in scope.row.observations" 
                       :key="index"
                       :content="obs.message"
                       placement="top">
              <el-tag :type="obs.type === 'error' ? 'danger' : 'warning'"
                     size="mini"
                     class="observation-tag">
                <i :class="obs.type === 'error' ? 'fas fa-exclamation-triangle' : 'fas fa-info-circle'"></i>
                {{ getObservationLabel(obs) }}
              </el-tag>
            </el-tooltip>
          </div>
          <span v-else class="no-observations">-</span>
        </el-table-column>
        <el-table-column
          align="center"
          label="Acciones"
          width="80"
          v-slot="scope">
            <a class="el-icon-delete delete-soc-icon"
               @click="deleteSuborder(scope.row.suborder)"/>
            <GoGeo v-model="scope.row.geostate"
                   @action="checkFilterInCentroide"
                   :suborder="scope.row.suborder"/>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        v-if="this.suborders.length > 0"
        layout="sizes, total, prev, pager, next"
        :page-size="this.pageSize"
        :page-sizes="this.pageSizes"
        :pager-count="5"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :total="this.suborders.length">
      </el-pagination>
    </div>
    <SuborderSplit v-model="list"
                   :splitsCount="list | len"
                   :sectors="sectors"
                   ref="dialogSplit"/>
    <SuborderAdd ref="dialogAdd"
                 v-model="list"
                 :sectors="sectors"/>

    <LpnAdd ref="dialogAddLpn"
      v-model="list"
      :sectors="sectors"/>

    <GetTO ref="dialogGetTO"
           v-model="list"
           :sectors="sectors"/>

    <UploadExcel ref="dialogUploadExcel"
                 v-model="list"
                 :sectors="sectors"/>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import moment from 'moment';
import GoGeo from './GoGeo.vue';
import GetTO from './GetTO.vue';
import SuborderAdd from './Add.vue';
import LpnAdd from './Lpn.vue';
import SuborderSplit from './Split.vue';
import ActionSimple from './action/Simple.vue';
import SubTitle from '../../base/SubTitle.vue';
import GoogleMapsLoader from '../../maps/config';
import ActionMultiple from './action/Multiple.vue';
import UploadExcel from './UploadExcel.vue';

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    sectors: {
      type: Array,
      default() {
        return [];
      },
    },
    dataToGetTO: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  name: 'SuborderList',
  components: {
    GoGeo,
    GetTO,
    SubTitle,
    SuborderAdd,
    LpnAdd,
    ActionSimple,
    SuborderSplit,
    ActionMultiple,
    UploadExcel,
  },
  data() {
    return {
      checked: [],
      google: null,
      pageSize: 100,
      pageSizes: [10, 20, 30, 40, 50, 100],
      currentPage: 0,
      setSector: [],
      totalChecked: 0,
      list: this.value,
      filterPkg: [],
      filterDoc: [],
      filterState: [],
      filterDateAt: [],
      filterSector: [],
      filterLocality: [],
      optionsToForce: [],
      filterCentroide: false,
      exportCount: -1,
      codePlanning: Math.floor(Math.random() * (90000 - 10000)) + 10000,
    };
  },
  mounted() {
    const date = moment().format('YYMMDDHHmm');
    const historyCode = this.updateCode(date);
    this.$emit('updateCode', historyCode);
    GoogleMapsLoader.load((google) => {
      this.google = google;
    });
  },
  watch: {
    value: {
      handler(newValue) {
        this.list = newValue;
      },
      deep: true,
      immediate: true
    },
    list() {
      if (this.list.length === 0) this.currentPage = 0;
      this.$emit('input', this.list);
    },
    checked() {
      this.totalChecked = this.checked.length;
    },
  },
  filters: {
    len(data) {
      return data.filter(s => s.splits).length;
    },
    existNotFound(data) {
      return data.filter(s => s.current_do === -1).length < 1;
    },
  },
  methods: {
    // Método para obtener la etiqueta de la observación
    getObservationLabel(obs) {
      if (obs.type === 'error') {
        return 'Error';
      } else if (obs.message && obs.message.includes('No enviada')) {
        return 'Filtrada';
      } else {
        return 'Info';
      }
    },
    // Método para aplicar clases CSS a las filas según el estado
    getRowClassName({ row }) {
      let className = 'row-medium';
      
      if (row.hasError) {
        if (row.errorType === 'processing') {
          className += ' row-error-processing';
        } else if (row.errorType === 'filtered') {
          className += ' row-error-filtered';
        }
      }
      
      return className;
    },
    addSocs(mode) {
      switch (mode) {
        case 'DOCUMENTO':
          this.$refs.dialogGetTO.open(this.dataToGetTO);
          break;
        case 'LPN':
          this.$refs.dialogAddLpn.open();
          break;
        case 'EXCEL':
          // Abrir dialog para subir archivo Excel
          this.$refs.dialogUploadExcel.open();
          break;
        default:
          this.$refs.dialogAdd.open();
          break;
      }
    },
    getSectorColor(id) {
      return this.sectors.find(s => s.id === id).color;
    },
    pkgTypeName(soc) {
      return soc.package_type_name === 'NF' ? 'no informado por TRL' : soc.package_type_name;
    },
    formatVolumeWithoutUnit(soc) {
      const volume = Number(soc.volume);
      return Number.isFinite(volume) ? volume : '';
    },
    formatItemDescriptions(soc) {
      return (soc.items || [])
        .map(item => item.description)
        .filter(description => description)
        .join(' | ');
    },
    countItems(soc) {
      return (soc.items || [])
        .reduce((total, item) => total + (Number(item.quantity) || 0), 0);
    },
    exportXLSX(fileName) {
      const exportV2 = this.list.some(soc => soc.loadedWithVerifyV2);
      const excelData = this.list.map((soc, index) => {
        const row = {
          index: index + 1,
          suborder: soc.suborder,
          volume: this.formatVolume(soc),
          do: soc.current_do > 0 ? soc.current_do : '',
          document_type: soc.document_type_name,
          locality: soc.locality,
          state: soc.last_state_name,
          package: this.pkgTypeName(soc),
          requested: this.formatDate(soc),
          lpn: soc.lpn,
          volume_without_unit: this.formatVolumeWithoutUnit(soc),
        };
        if (exportV2) {
          const packageInfo = soc.package || {};
          const dimensions = packageInfo.dimensions || {};
          row.customer_full_name = soc.customer_full_name;
          row.customer_rut = soc.customer_rut;
          row.address = soc.raw_address;
          row.latitude = soc.lat;
          row.longitude = soc.lng;
          row.package_height = dimensions.height;
          row.package_width = dimensions.width;
          row.package_length = dimensions.length;
          row.package_weight = packageInfo.weight;
          row.description = this.formatItemDescriptions(soc);
          row.items_quantity = this.countItems(soc);
          row.items_json = JSON.stringify(soc.items || []);
        }
        return row;
      });
      const headers = [
        'index',
        'suborder',
        'volume',
        'do',
        'document_type',
        'locality',
        'state',
        'package',
        'requested',
        'lpn',
      ];
      if (exportV2) {
        headers.push(
          'customer_full_name',
          'customer_rut',
          'address',
          'latitude',
          'longitude',
          'package_height',
          'package_width',
          'package_length',
          'package_weight',
          'description',
          'items_quantity',
          'items_json',
        );
      }
      headers.push('volume_without_unit');
      const data = XLSX.utils.json_to_sheet(
        excelData,
        {
          header: headers,
        },
      );
      data.A1.v = 'No';
      data.B1.v = 'SUBORDEN';
      data.C1.v = 'Vol.';
      data.D1.v = 'DO';
      data.E1.v = 'TIPO';
      data.F1.v = 'LOCALIDAD';
      data.G1.v = 'ESTADO';
      data.H1.v = 'TAMAÑO';
      data.I1.v = 'FECHA';
      data.J1.v = 'LPN';
      if (exportV2) {
        data.K1.v = 'NOMBRE_CLIENTE';
        data.L1.v = 'RUT_CLIENTE';
        data.M1.v = 'DIRECCION';
        data.N1.v = 'LATITUD';
        data.O1.v = 'LONGITUD';
        data.P1.v = 'PAQUETE_ALTO';
        data.Q1.v = 'PAQUETE_ANCHO';
        data.R1.v = 'PAQUETE_LARGO';
        data.S1.v = 'PAQUETE_PESO';
        data.T1.v = 'DESCRIPCION';
        data.U1.v = 'CANTIDAD_ITEMS';
        data.V1.v = 'ITEMS_JSON';
      }
      const volumeColumn = exportV2 ? 'W' : 'K';
      data[`${volumeColumn}1`].v = 'VOLUMEN';
      for (let rowIndex = 0; rowIndex < excelData.length; rowIndex += 1) {
        const volumeCell = data[`${volumeColumn}${rowIndex + 2}`];
        if (volumeCell && volumeCell.t === 'n') volumeCell.z = '0.0000';
      }
      const workbook = XLSX.utils.book_new();
      const date = moment().format('YYMMDDHHmm');
      const historyCode = this.updateCode(date);
      this.$emit('updateCode', historyCode);
      XLSX.utils.book_append_sheet(workbook, data, fileName);
      XLSX.writeFile(
        workbook,
        `${fileName}_${date}.xlsx`,
        { Props: { Comments: `${historyCode}` } },
      );
    },
    updateCode(date) {
      this.exportCount = this.exportCount + 1;
      return `${this.codePlanning}_${this.exportCount}_${date}`;
    },
    inCentroide() {
      this.currentPage = 0;
      this.filterCentroide = !this.filterCentroide;
    },
    checkFilterInCentroide() {
      this.filterCentroide = this.suborders.filter(s => s.geostate === 4).length > 0;
    },
    getSplits() {
      this.$refs.dialogSplit.openModal();
    },
    async copyNotFound() {
      const socs = this.list.filter(s => this.notFound(s)).map(s => s.suborder);
      const base = `Se han copiado ${socs.length}`;
      const countText = socs.length > 1 ? `${base} elementos` : `${base} elemento`;
      await navigator.clipboard.writeText(socs.join('\r\n')).then(
        this.$notify.success({ title: countText }),
      );
    },
    handleCurrentChange(val) {
      this.currentPage = val - 1;
    },
    handleSizeChange(val) {
      this.currentPage = 0;
      this.pageSize = val;
    },
    applyFilter(filters) {
      this.currentPage = 0;
      if (filters.package) this.filterPkg = filters.package;
      if (filters.states) this.filterState = filters.states;
      if (filters.sector) this.filterSector = filters.sector;
      if (filters.document) this.filterDoc = filters.document;
      if (filters.locality) this.filterLocality = filters.locality;
      if (filters.requested) this.filterDateAt = filters.requested;
    },
    getSectorById(soc) {
      return this.sectors.filter((sector) => {
        if ((sector.packageTypes.map(pt => pt.id).includes(soc.package_type_id)
          || (sector.packageTypes.length > 0 && soc.package_type_name === 'NF'))
          && this.validateZone(sector, soc)
          && !(this.haveSplits(soc) || this.notPlannable(soc))) {
          // eslint-disable-next-line no-param-reassign
          soc.forceSector = null;
          return true;
        }
        return false;
      });
    },
    validateZone(sector, soc) {
      if (sector.mode === 'POLÍGONO') {
        const coordinate = new this.google.maps.LatLng(parseFloat(soc.lat), parseFloat(soc.lng));
        const polygon = new this.google.maps.Polygon({ path: sector.polygon });
        return this.google.maps.geometry.poly.containsLocation(coordinate, polygon);
      }
      return sector.localities.map(l => l.name).includes(soc.locality);
    },
    getSectorForce(soc) {
      const sectors = this.sectors.filter(s => s.id === soc.forceSector);
      // eslint-disable-next-line no-param-reassign
      if (sectors.length === 0) soc.forceSector = null;
      return sectors;
    },
    getSectorOfSuborder(soc) {
      // eslint-disable-next-line no-param-reassign
      soc.sectors = this.getSectorForce(soc);
      this.$notify.success({ title: 'Sector asignado con éxito' });
    },
    formatDate(row) {
      // const date = moment.utc(row.requested_at).locale('es').format('D MMM');
      const date = moment.utc(row.requested_at).format('DD/MM/YY');
      return ['01/01/01', '01/01/70'].includes(date) ? '' : date;
    },
    formatVolume(row) {
      return row.volume ? `${row.volume.toFixed(2)} mt³` : '';
    },
    notFound(soc) {
      return soc.current_do === -1;
    },
    haveSplits(soc) {
      return soc.splits;
    },
    notPlannable(soc) {
      return [5, 6].includes(soc.last_state);
    },
    handleSelectionChange(val) {
      this.checked = val.map(s => s.suborder);
    },
    deleteSocs(option) {
      if (option === 0) {
        this.deleteAllSelected();
      } else if (option === 1) {
        this.deleteAllPaginated();
      }
    },
    deleteAllPaginated() {
      this.$confirm('¿Está seguro que desea eliminar las socs paginadas?', 'Advertencia', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.list = this.list
          .filter(s => this.suborders
            .findIndex(val => val.suborder === s.suborder) === -1);
        this.checked = [];
        this.clearFilter();
        this.verifyPaged();
        this.$emit('input', this.list);
        this.$notify.success({ title: 'Subordenes eliminadas con éxito' });
      }).catch(() => {});
    },
    deleteAllSelected() {
      this.$confirm('¿Está seguro que desea eliminar las socs seleccionadas?', 'Advertencia', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.list = this.list
          .filter(s => this.checked
            .findIndex(val => val === s.suborder) === -1);
        this.checked = [];
        this.clearFilter();
        this.verifyPaged();
        this.$emit('input', this.list);
        this.$notify.success({ title: 'Subordenes eliminadas con éxito' });
      }).catch(() => {});
    },
    deleteSuborder(soc) {
      this.$confirm('¿Está seguro que desea eliminar la soc?', 'Advertencia', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.list = this.list.filter(s => s.suborder !== soc);
        if (this.list.length === 0) this.checked = [];
        this.verifyPaged();
        this.$emit('input', this.list);
        this.$notify.success({ title: 'Suborden eliminada con éxito' });
      }).catch(() => {});
    },
    verifyPaged() {
      if (this.suborderPaged.length === 0
        && this.currentPage > 0) this.currentPage = this.currentPage - 1;
    },
    clearFilter() {
      this.filterPkg = [];
      this.filterDoc = [];
      this.filterState = [];
      this.filterDateAt = [];
      this.filterSector = [];
      this.filterLocality = [];
      this.filterCentroide = false;
      if (this.$refs.tableSuborder) this.$refs.tableSuborder.clearFilter();
    },
    getOptionsToForce() {
      this.$refs.cascadeSuborder.panel.activePath = [];
      const children = this.sectors.map(s => ({ value: s.id, label: s.name }));
      this.optionsToForce = [{
        value: 'selected',
        label: `seleccionadas (${this.totalChecked})`,
        disabled: this.totalChecked < 1,
        children,
      }, {
        value: 'paginated',
        label: `paginadas (${this.suborders.length})`,
        disabled: this.suborders.length < 1,
        children,
      }];
    },
    SetSectorMassive() {
      if (this.setSector[0] === 'selected') {
        this.setMassive(this.checked, this.setSector[1]);
      } else if (this.setSector[0] === 'paginated') {
        this.setMassive(this.suborders.map(s => s.suborder), this.setSector[1]);
      }
    },
    setMassive(socs, sectorId) {
      this.list.forEach((s) => {
        if (socs.includes(s.suborder)
          && !(this.haveSplits(s) || this.notFound(s) || this.notPlannable(s))) {
          // eslint-disable-next-line no-param-reassign
          s.forceSector = sectorId;
          // eslint-disable-next-line no-param-reassign
          s.sectors = this.getSectorForce(s);
        }
      });
      this.setSector = [];
      this.$refs.tableSuborder.clearSelection();
      this.$notify.success({ title: 'Sector asignado con éxito' });
    },
    getErrors() {
      const err = [];
      const countWithoutSector = this.list.filter(s => !s.sectors || s.sectors.length < 1).length;

      if (this.list.length < 1) err.push('No se ha ingresado ninguna soc');

      this.$emit('errors', err);
      this.$emit('countSocWithoutSector', countWithoutSector);
    },
  },
  computed: {
    optionsToDelete() {
      return [{
        name: `seleccionadas (${this.totalChecked})`,
        disabled: this.totalChecked < 1,
      }, {
        name: `paginadas (${this.suborders.length})`,
        disabled: this.suborders.length < 1,
      }];
    },
    disabledMassiveOptions() {
      return this.totalChecked < 1 && this.suborders.length < 1;
    },
    filterEnable() {
      return this.filterPkg.length > 0
          || this.filterDoc.length > 0
          || this.filterState.length > 0
          || this.filterSector.length > 0
          || this.filterDateAt.length > 0
          || this.filterLocality.length > 0
          || this.filterCentroide === true;
    },
    suborderPaged() {
      return this.suborders
        .slice(this.currentPage * this.pageSize, (this.currentPage + 1) * this.pageSize);
    },
    suborders() {
      this.getErrors();
      return this.list.map((soc) => {
        const sectors = this.getSectorForce(soc).length > 0
          ? this.getSectorForce(soc) : this.getSectorById(soc);
        return Object.assign(soc, { sectors });
      }).filter((s) => {
        const filter = [];
        if (this.filterState.length > 0) filter.push(this.filterState.includes(s.last_state));
        if (this.filterPkg.length > 0) filter.push(this.filterPkg.includes(s.package_type_name));
        if (this.filterLocality.length > 0) filter.push(this.filterLocality.includes(s.locality));
        if (this.filterDoc.length > 0) filter.push(this.filterDoc.includes(s.document_type_name));
        if (this.filterDateAt.length > 0) filter.push(this.filterDateAt.includes(s.requested_at));
        if (this.filterSector.length) {
          const filterThisSector = [];
          
          // Verificar sectores del Excel
          if (s.excelSector) {
            filterThisSector.push(this.filterSector.includes(s.excelSector));
          }
          
          // Verificar sectores del sistema
          if (s.sectors.length > 0) {
            s.sectors.forEach((thisSector) => {
              filterThisSector.push(this.filterSector.includes(thisSector.name));
            });
          } else if (this.filterSector.includes('Sin sector') && !s.excelSector) {
            filterThisSector.push(true);
          } else if (!s.excelSector && s.sectors.length === 0) {
            filterThisSector.push(false);
          }
          
          filter.push(filterThisSector.reduce((acum, el) => acum || el, false));
        }
        if (this.filterCentroide) filter.push(s.geostate === 4);
        return filter.reduce((acum, el) => acum && el, true);
      });
    },
    filterSectorData() {
      this.getErrors();
      
      // Obtener sectores del sistema
      const systemSectors = this.sectors.slice().map(sector => ({ text: sector.name, value: sector.name }));
      
      // Obtener sectores únicos del Excel
      const excelSectors = [...new Set(this.list
        .filter(s => s.excelSector)
        .map(s => s.excelSector))]
        .map(sector => ({ text: `${sector} (Excel)`, value: sector }));
      
      return systemSectors
        .concat(excelSectors)
        .concat({ text: 'Sin sector', value: 'Sin sector' })
        .sort((a, b) => (b.text > a.text ? -1 : 1));
    },
    filterStateData() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt) => {
          const lastStateName = pt.last_state < 0 ? '(Vacío)' : pt.last_state_name;
          return ({ text: lastStateName, value: pt.last_state });
        })
        .filter((pt, i, acum) => acum
          .findIndex(t => t.value === pt.value) === i);
    },
    filterPackageTypeData() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt) => {
          // eslint-disable-next-line no-nested-ternary
          const packageTypeName = this.notFound(pt)
            ? '(Vacío)' : this.pkgTypeName(pt);
          return ({ text: packageTypeName, value: pt.package_type_name });
        })
        .filter((pt, i, acum) => acum
          .findIndex(t => t.value === pt.value) === i);
    },
    filterLocalityData() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt) => {
          const locality = pt.locality === '' ? '(Vacío)' : pt.locality;
          return ({ text: locality, value: pt.locality });
        })
        .filter((pt, i, acum) => acum.findIndex(t => t.text === pt.text) === i)
        .sort((a, b) => (b.text > a.text ? -1 : 1));
    },
    filterDocumentTypeData() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt) => {
          const document = pt.document_type_name === '' ? '(Vacío)' : pt.document_type_name;
          return ({ text: document, value: pt.document_type_name });
        })
        .filter((pt, i, acum) => acum.findIndex(t => t.text === pt.text) === i)
        .sort((a, b) => (b.text > a.text ? -1 : 1));
    },
    filterRequestedAtData() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt) => {
          const date = moment.utc(pt.requested_at).format('DD/MM/YY');
          const requestedAt = ['01/01/01', '01/01/70'].includes(date) ? '(Vacío)' : date;
          return ({ text: requestedAt, value: pt.requested_at });
        })
        .filter((pt, i, acum) => acum.findIndex(t => t.text === pt.text) === i)
        .sort((a, b) => (b.value > a.value ? -1 : 1));
    },
  },
};
</script>

<style lang="scss" scoped>
  .left { float: left; }
  .right { float: right; }
  .card-section {
    border-radius: 3px;
    border: 1px solid #eaeaea;
    .msg-not-sector {
      color: $fb-grey-light-70;
      font-size: 12px;
      font-weight: 700;
      margin: 20px 12px;
      text-align: center;
    }
    .card-navbar {
      padding: 0 2px;
      font-size: 13px;
      text-align: left;
      margin-bottom: 10px;
      .right { float: right; }
      border-bottom: 1px solid #eaeaea;
    }
  }
  .sector-tag {
    color: white;
    margin-right: 5px;
    padding: 2px 10px;
    border-radius: 3px;
  }
  .excel-sector-tag {
    color: #28a745;
    margin-right: 5px;
    padding: 2px 8px;
    border-radius: 3px;
    border: 1px solid #28a745;
    background-color: #d4edda;
    font-size: 12px;
    font-weight: 600;
    i {
      margin-right: 4px;
      color: #28a745;
    }
  }
  .action-socs-btn, .action-sub-btn {
    border: none;
    i { font-weight: 900; }
    span { margin-left: 7px; }
  }
  .action-socs-btn {
    padding: 6px 12px;
    margin: 0 0 5px 10px;
  }
  .action-sub-btn {
    padding: 0;
    color: $fb-green;
    margin: 10px 12px 0 12px;
    text-decoration: underline;
    background-color: white !important;
  }
  #disable-link-delete, #disable-link-clean { background-color: white !important; }
  .delete-soc-icon {
    margin: 7px 0;
    font-size: 14px;
    cursor: pointer;
  }
  .delete-soc-icon:hover { color: $fb-red-light-20; }
  .select-sectors {
    margin-right: 16px;
    width: 300px !important;
  }
  .tag-red {
    color: white;
    height: 19px;
    padding: 0 10px;
    font-size: 12px;
    line-height: 1.6;
    text-align: center;
    border-radius: 15px;
    display: inline-block;
    background-color: $fb-red-light-20;
  }
  .status-soc {
    width: 15px;
    display: inline-block;
    .fa-cubes {
      color: $fb-amber;
      margin-right: 4px;
    }
    i { vertical-align: middle; }
    .fa-times { margin-right: 8px; }
    .fa-question { margin-right: 7px; }
    .fa-times, .fa-question { color: $fb-red-light-20; }
  }
  .circle-color {
    width: 12px;
    height: 12px;
    border-radius: 20px;
    display: inline-block;
    margin: 0 4px -1px -10px;
  }
  .label-set-sector {
    color: #555;
    font-size: 10px;
    font-weight: 500;
    margin: 12px 8px 0 8px;
  }
  
  // Estilos para filas con errores
  :deep(.row-error-processing) {
    background-color: #fef0f0 !important;
    border-left: 4px solid #f56c6c !important;
    
    &:hover {
      background-color: #fde2e2 !important;
    }
  }
  
  :deep(.row-error-filtered) {
    background-color: #fdf6ec !important;
    border-left: 4px solid #e6a23c !important;
    
    &:hover {
      background-color: #faecd8 !important;
    }
  }
  
  // Estilos para la columna de observaciones
  .observations-column {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    
    .observation-tag {
      margin: 2px 0;
      
      i {
        margin-right: 4px;
      }
    }
  }
  
  .no-observations {
    color: #c0c4cc;
    font-style: italic;
  }
</style>
